<template>
    <div>
        <v-col class="my-0 py-0 px-0 px-md-8 pb-15">
            <v-col class="text-start mt-5 mb-3">
                <v-alert text dense color="#8061c2" border="left" class="pl-5">
                    <h1 class="title mt-1">Historial de envio para correos</h1>
                    <p class="desc mt-0 mb-1">Registro de correos enviados a usuarios</p>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#7E57C2"
                    label
                    outlined
                    >Total correos enviados: &nbsp; <strong>{{ totalsEmails.emails }}</strong></v-chip>
                </v-alert>
            </v-col>

            <!-- Tabla de emails history -->
            <v-data-table
            :headers="headers"
            :items="emails"
            :items-per-page="perPage"
            :loading="loading"
            fixed-header
            height="calc(100hv - 250px)"
            :server-items-length="totalEmails"
            :page.sync="page"
            class="elevation-1 mx-3 px-2 py-4 logs-table"
            :footer-props="{
                    itemsPerPageOptions: [50, 100, 200, -1],
                    showFirstLastPage: true
            }"
            @update:items-per-page="updatePerPage"
            @pagination="fetchEmails"
            >
            <template v-slot:item.admin.email="{ item }">
                <div>
                    {{ item.admin?.email || 'N/A' }}
                </div>
            </template>

            <template v-slot:item.subject="{ item }">
                {{ item.subject ? item.subject.substring(0,10) : 'N/A' }}
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                    v-if="item.subject && item.subject.length > 8"
                    small
                    class="ml-1"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="openDialog(item.description, item.subject)"
                    >
                    mdi-dots-horizontal
                    </v-icon>
                </template>
                <span>Ver más</span>
                </v-tooltip>
            </template>

            <template v-slot:item.description="{item}">
                {{ item.description ? item.description.substring(0, 38) : 'N/A' }}
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-icon v-if="item.subject && item.subject.length > 8"
                    small
                    class="ml-1"
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    @click="openDialog(item.description, item.subject)"
                    >mdi-dots-horizontal</v-icon>
                </template>
                <span>Ver más</span>
                </v-tooltip>
            </template>

            <template v-slot:item.user.email="{ item }">
                <div>
                    {{ item.user?.email || 'N/A' }}
                </div>
            </template>

            <template v-slot:item.created_at="{ item }">
                <div>
                    {{ formatDate(item.created_at) }}
                </div>
            </template>
            </v-data-table>
        </v-col>

        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-card-title class="text-h5 px-12 py-7">{{ selectedSubject }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text-justify pt-4">{{ selectedDescription }}</v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from '@/axios.js';
export default {
    data() {
        return {
            emails: [],
            dialog: false,
            selectedDescription: '',
            selectedSubject: '',
            totalEmails: 0,
            page: 1,
            perPage: 50,
            loading: false,
            headers: [
                { text: 'Remitente', value: 'admin.email' },
                { text: 'Asunto', value: 'subject' },
                { text: 'Mensaje', value: 'description' },
                { text: 'Receptor', value: 'user.email' },
                { text: 'Fecha', value: 'created_at' }
            ]
        };
    },
    computed: {
        totalsEmails(){
            const emails = Number(this.totalEmails);
            if(!isNaN(emails)){
                return{
                    emails: emails.toLocaleString('en-US')
                }
            }else{
                return{
                    emails: '0'
                }
            }
        }
    },
    methods: {
        async fetchEmails() {
        this.loading = true;
        try {
            const response = await axios.get('/admin/get-email-history', {
            params: {
                page: this.page,
                per_page: this.perPage
            }
            });
            this.emails = response.data.data;
            this.totalEmails = response.data.totalEmails;

        } catch (error) {
            console.error('Error al obtener historial de correos:', error);
        } finally {
            this.loading = false;
        }
        },
        formatDate(dateStr) {
        const date = new Date(dateStr);
        return date.toLocaleString();
        },
        openDialog(description, subject){
            this.selectedDescription = description
            this.selectedSubject = subject
            this.dialog = true
        },
        updatePerPage(value){
            this.perPage = value;
            this.page = 1;
            this.fetchEmails();
        },
    },
    mounted() {
        this.fetchEmails();
    }
};
</script>

<style scoped>
</style>
